<template>
  <v-container>
    <v-row>
      <v-radio-group
        v-model="newReceipt.type"
        row
      >
        <v-radio
          label="نقدی"
          value="cash"
        />
        <v-radio
          label="کارت بانکی"
          value="card"
        />
        <v-radio
          label="چک"
          value="check"
        />
        <v-radio
          label="سایر"
          value="other"
        />
      </v-radio-group>
      <div
        style="width: 100%"
        v-if="newReceipt.type"
        class="mx-auto"
      >
        <payment
          :offline-submit="true"
          :account-prop = accountProp
          @addPayment ="addPayment"
        />
      </div>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      Payment: () => import('../../treasury/payments.vue'),
    },
    data () {
      return {
        amount: null,
        date: null,
        dialog: false,
        menu: false,
        valid: false,
        newReceipt: {
          type: '',
          amount: '',
          date: '',
          notes: '',
        },
        headers: [
          { text: 'نوع دریافت', value: 'type' },
          { text: 'مبلغ', value: 'amount' },
          { text: 'تاریخ', value: 'date' },
          { text: 'توضیحات', value: 'notes' },
          { text: 'عملیات', value: 'actions', sortable: false },
        ],
        receipts: [],
      }
    },
    props: ['accountProp'],
    watch: {
      accountProp (val) {
      },
    },
    computed: {
      totalReceived () {
        return this.receipts.reduce((sum, receipt) => sum + parseFloat(receipt.amount), 0)
      },
    },
    mounted () {
    },
    methods: {
      addPayment (data) {
      },
      saveReceipt () {
        if (this.$refs.form.validate()) {
          this.receipts.push({ ...this.newReceipt })
          this.newReceipt = {
            type: '',
            amount: '',
            date: '',
            notes: '',
          }
          this.dialog = false
        }
      },
      editReceipt (item) {
      // کد ویرایش دریافت
      },
      deleteReceipt (item) {
        const index = this.receipts.indexOf(item)
        if (index !== -1) {
          this.receipts.splice(index, 1)
        }
      },
    },
  }
</script>

<style scoped>

</style>
